import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import comentIcon from "../../assets/comentIcon.svg";
import logoIvi from "../../assets/logo.svg";
import question from "../../assets/question.svg";
import ButtonComponent from "../../components/ButtonComponent";
import LeftHomeComponent from "../../components/leftHomeComponent/LeftHomeComponent";
import MainHomeComponent from "../../components/MainHomeComponent/MainHomeComponent";
import RightHomeComponent from "../../components/RightHomeComponent/RightHomeComponent";
import CardInformation from "../../components/card/CardInformation";
import "./confirmYourData.css";
import CardConfirmYourData from "../../components/card/CardConfirmYourData/CardConfirmYourData";
import DataHolder from "../../components/card/CardConfirmYourData/DataHolder/DataHolder";
import DataContact from "../../components/card/CardConfirmYourData/DataContact/DataContact";
import InstallationData from "../../components/card/CardConfirmYourData/InstallationData/InstallationData";
import { RedirectContext } from "../../context/redirect";
import { useMutation } from "@tanstack/react-query";
import { Cupom, DadosTitularPjProps, Distribuidora, confirmarDadosLead, termo } from "../../services/onboarding";
import { POST_CONFIRMAR_DADOS_LEAD, POST_PREPARE_TERM } from "../../query/constants";
import CnpjHolder from "../../components/card/CardConfirmYourData/CnpjHolder/CnpjHolder";
import { SessionContext } from "../../context/session";
import { setItemLocalStorage } from "../../utils/localStorage";
import LoadingFullPage from "../../components/Loading/LoadingFullPage/LoadingFullPage";
import { AxiosError } from "axios";
import { economiaAnual } from "../../utils/calculoFinal";
import { valorFornecimento } from "../../utils/valorFornecimento";
import { useGetProtectedLead } from "../../hooks/useGetProtectedLead";
import { useTenantStore } from "../../stores/tenant/use-tenant-store";
import { NewModalRef } from "../../components/modal/NewModal/NewModal";
import ConfirmFaturaDigitalModal from "./ConfirmFaturaDigitalModal/ConfirmFaturaDigitalModal";
import { FluxoType } from "../../stores/tenant/tenant.types";

type DatasHolderProps = {
  nome: string;
  nacionalidade: string;
  cpf: string;
  rg?: string;
  rne?: string;
  maritalStatus: string;
};

export const ConfirmYourData = () => {
  const { assets, type, texts } = useTenantStore();
  const { mutate, data, isPending } = useGetProtectedLead();
  const modalRef = useRef<NewModalRef>(null);

  useEffect(() => {
    mutate();
  }, [mutate]);

  const isCustomerFromParceiro = !!data?.dadosParceiro?.emailDealer;
  const isFluxoAutosservicoType = type === FluxoType.AUTOSSERVICO;
  const editEnabled = !(isCustomerFromParceiro && isFluxoAutosservicoType);

  const { getItemSession, setItemSession } = useContext(SessionContext);

  const isSigner = getItemSession("isSigner");
  const appliedCupom = getItemSession("appliedCupom");
  const cupom = appliedCupom ? JSON.parse(appliedCupom || "{}") as Cupom : null;

  const navigate = useNavigate();
  const [dadosDistribuidora, setDadosDistribuidora] = useState<Distribuidora | null>(null);
  const { setPathEdit, pathEdit } = useContext(RedirectContext);
  const [holderCnpj, setHolderCnpj] = useState(false);
  const [cnpjLegalRepresentative, setCnpjLegalRepresentative] = useState<DadosTitularPjProps>({
    CNPJ: "",
    RazaoSocial: "",
  });
  const [otherData, setOtherData] = useState({
    discount: 0,
    consumoMensal: "",
    economiaAnual: "",
    expectedEconomy: 0,
    numberInstallation: 0,
    address: "",
  });
  const [datasContact, setDatasContact] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [datasHolder, setDatasHolder] = useState<DatasHolderProps>({
    nome: "",
    nacionalidade: "",
    cpf: "",
    rg: "",
    rne: "",
    maritalStatus: "",
  });

  const prepareTerm = useMutation({
    mutationFn: termo,
    mutationKey: [POST_PREPARE_TERM],
    onSuccess: (data) => {
      setItemSession("term", data);
      navigate("/contract-of-adhesion");
    },
    onError(error: AxiosError) {
      console.log(error.response?.status);
    },
  });

  const confirmarDadosLeadMutation = useMutation({
    mutationFn: confirmarDadosLead,
    mutationKey: [POST_CONFIRMAR_DADOS_LEAD],
    onSuccess: () => {
      nextStep();
    },
  });

  useEffect(() => {
    if (isPending || !data) return;

    const isSigner = getItemSession("isSigner");
    const arquivo: string | null = getItemSession("dados-fatura");
    const contact: string | null = getItemSession("contact");
    const holderCPFDataStorage: string | null = getItemSession("holderData");
    const holderCnpjStorage: string | null = getItemSession("holderCNPJ");
    const cnpj: string | null = getItemSession("cnpj");
    const dadosDistribuidora = getItemSession("dados-distribuidora") ? JSON.parse(getItemSession("dados-distribuidora")!) : null;
    setDadosDistribuidora(dadosDistribuidora);

    if (arquivo != null && dadosDistribuidora != null) {
      const desconto = dadosDistribuidora.descontoPadrao;
      const tarifa = dadosDistribuidora.tarifaVigente;
      let arquivopdf = JSON.parse(arquivo);
      const consumoMediao = arquivopdf.consumoMedio;
      const fornecimento = arquivopdf.fornecimento;

      const fornecimentoValue = valorFornecimento(fornecimento);

      const resposta = economiaAnual(fornecimentoValue, consumoMediao, tarifa, desconto);
      let opcoesEconomia = {
        style: "decimal" as any,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      let opcoesConsumo = {
        style: "decimal" as any,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      };

      setOtherData({
        ...otherData,
        discount: desconto * 100,
        consumoMensal: arquivopdf.consumoMedio?.toLocaleString("pt-BR", opcoesConsumo),
        economiaAnual: resposta?.toLocaleString("pt-BR", opcoesEconomia),
        numberInstallation: arquivopdf.numeroInstalacao,
        address: arquivopdf.endereco,
      });
    }

    if (cnpj != null) {
      const cnpjObj = JSON.parse(cnpj);
      // console.log("cnpj e razao:", cnpjObj);
      setHolderCnpj(true);
      setCnpjLegalRepresentative(cnpjObj);
    }
    if (cnpj != null && holderCnpjStorage != null) {
      let inforHolderCNPJ = JSON.parse(holderCnpjStorage);
      // setHolderCnpj(false);

      setDatasHolder({
        ...datasHolder,
        nome: inforHolderCNPJ.nome,
        nacionalidade: inforHolderCNPJ.selectedNacionalidades,
        cpf: inforHolderCNPJ.cpf,
        [inforHolderCNPJ.rg ? "rg" : "rne"]: inforHolderCNPJ.rg ? inforHolderCNPJ.rg : inforHolderCNPJ.rne,
        maritalStatus: inforHolderCNPJ.selectedMaritalStatus,
      });
    }
    if (contact != null) {
      let infoContact = JSON.parse(contact);
      setDatasContact({
        ...datasContact,
        name: infoContact.name,
        email: infoContact.email,
        phone: infoContact.phone,
      });
    }

    if (holderCPFDataStorage != null) {
      let inforHolderCPF = JSON.parse(holderCPFDataStorage);
      setDatasHolder({
        ...datasHolder,
        nome: inforHolderCPF.nome,
        nacionalidade: inforHolderCPF.selectedNacionalidades,
        cpf: inforHolderCPF.storageCpf,
        [inforHolderCPF.rg ? "rg" : "rne"]: inforHolderCPF.rg ? inforHolderCPF.rg : inforHolderCPF.rne,
        maritalStatus: inforHolderCPF.selectedMaritalStatus,
      });
    }
  }, [isPending]);

  const handleBackButtonClick = () => {
    // Lógica a ser executada ao clicar no botão
    navigate("/installation");
  };

  const handleButtonClick = () => {
    //const faturaStorage = getItemSession("formData");
    if (pathEdit) {
      setPathEdit("");
    }
    const contato = {
      Nome: datasContact.name,
      Telefone: datasContact.phone,
    };
    const documentoOficial = datasHolder.rg ? datasHolder.rg : datasHolder.rne;
    if (documentoOficial) {
      const dadosUpdate = {
        CPF: datasHolder.cpf,
        EstadoCivil: datasHolder.maritalStatus,
        Nacionalidade: datasHolder.nacionalidade,
        Nome: datasHolder.nome,
        RG: documentoOficial,
      };
      confirmarDadosLeadMutation.mutate({
        Contato: { ...contato },
        dadosRepresentante: { ...dadosUpdate },
        isCnpj: holderCnpj,
      });
    }
  };

  // const cardTitle = "Você economizará";
  const cardDiscount = `${otherData.discount.toFixed(0)}`;
  const cardOtherData = {
    consumoMensal: `${otherData.consumoMensal} kWh`,
    economiaAnual: `R$ ${otherData.economiaAnual}`,
    expectedEconomy: `R$ ${otherData.expectedEconomy}`,
  };

  const installationDataTitle = "Dados do imóvel";
  const installationData = {
    distributor: `${dadosDistribuidora?.nome || "N/A"}`,
    numberInstallation: `${otherData.numberInstallation || "N/A"}`,
    address: `${otherData.address || "N/A"}`,
  };

  const holderDataTitle = "Dados do Titular";
  const representanteLegal = "Dados do Representante Legal";

  const holderData = {
    name: `${datasHolder.nome}`,
    nationalite: `${datasHolder.nacionalidade}`,
    cpf: `${datasHolder.cpf}`,
    rgRneLabel: datasHolder.rg ? "RG" : "RNE",
    rgRneValue: `${datasHolder.rg ? datasHolder.rg : datasHolder.rne}`,
    maritalStatus: `${datasHolder.maritalStatus}`,
  };

  const dadosTitularCNPJ = {
    cnpj: `${cnpjLegalRepresentative.CNPJ}`,
    razao: `${cnpjLegalRepresentative.RazaoSocial}`,
  };

  const contactDataTitle = "Dados de Contato";
  const contactData = {
    name: `${datasContact.name}`,
    email: `${datasContact.email}`,
    phone: `${datasContact.phone}`,
  };

  const handleEditInstallationData = () => {
    sessionStorage.setItem("path", "/confirm-your-data");
    navigate(type === FluxoType.CONSULTOR ? "/distribuidora" : "/");
  };

  const handleEditHolderData = () => {
    if (holderCnpj) {
      setItemLocalStorage("path", "/confirm-your-data");
      navigate("/holder");
    }
    setItemLocalStorage("path", "/confirm-your-data");
    navigate("/create-holder");
  };

  const handleEditContactData = () => {
    setItemLocalStorage("path", "/confirm-your-data");
    navigate("/contact");
  };

  const handleEditHolderDataCNPJ = () => {
    setItemLocalStorage("path", "/confirm-your-data");
    navigate("/create-holder-cnpj");
  };

  const nextStep = () => {
    if (type === FluxoType.CONSULTOR) {
      navigate("/registration-completed");
    } else {
      prepareTerm.mutate();
    }
  };

  return (
    <MainHomeComponent>
      <LeftHomeComponent
        logoSrc={logoIvi}
        title={texts.confirmYourData.title}
        description={texts.confirmYourData.description}
        imgSrc={assets.confirmYourData.image}
      />
      <RightHomeComponent
        questionSrc={question}
        commentIconSrc={comentIcon}
        cardHomeClass="card-comfirmData"
        title={texts.confirmYourData.title}
        description={texts.confirmYourData.description}
      >
        <div className="card-container-confirm">
          <CardInformation
            discount={cardDiscount || "0"}
            consumoMensal={cardOtherData.consumoMensal || "0 kWh"}
            economiaAnual={cardOtherData.economiaAnual || "R$ 0,00"}
            cupom={cupom}
          />

          {/* Dados da Instalação: */}
          <CardConfirmYourData title={installationDataTitle} onEditClick={handleEditInstallationData} editEnabled={editEnabled}>
            <InstallationData
              distributor={installationData.distributor || "N/A"}
              numberInstallation={installationData.numberInstallation || "N/A"}
              address={installationData.address || "N/A"}
            />
            {/* <InstallationData data={installationData} /> */}
          </CardConfirmYourData>

          {/* Dados do TitularCNPJ/CPF: */}
          {holderCnpj ? (
            <CardConfirmYourData title={holderDataTitle} editEnabled={editEnabled}>
              <CnpjHolder cnpj={dadosTitularCNPJ.cnpj} social={dadosTitularCNPJ.razao} />
              {/* <DataHolder data={dadosTitularCNPJ} /> */}
            </CardConfirmYourData>
          ) : (
            <CardConfirmYourData title={holderDataTitle} onEditClick={handleEditHolderData} editEnabled={editEnabled}>
              <DataHolder
                name={holderData.name || "N/A"}
                nationalite={holderData.nationalite || "N/A"}
                cpf={holderData.cpf || "N/A"}
                rgRneLabel={holderData.rgRneLabel || "N/A"}
                rgRneValue={holderData.rgRneValue || "N/A"}
                maritalStatus={holderData.maritalStatus || "N/A"}
              />
            </CardConfirmYourData>
          )}

          {/* Dados do Representante Legal: */}

          {holderCnpj && (
            <CardConfirmYourData title={representanteLegal} onEditClick={handleEditHolderDataCNPJ} editEnabled={editEnabled}>
              <DataHolder
                name={holderData.name || "N/A"}
                nationalite={holderData.nationalite || "N/A"}
                cpf={holderData.cpf || "N/A"}
                rgRneLabel={holderData.rgRneLabel || "N/A"}
                rgRneValue={holderData.rgRneValue || "N/A"}
                maritalStatus={holderData.maritalStatus || "N/A"}
              />
              {/* <DataHolder data={holderData} /> */}
            </CardConfirmYourData>
          )}

          {/* Dados de contato: */}
          <CardConfirmYourData title={contactDataTitle} onEditClick={handleEditContactData} editEnabled={editEnabled}>
            <DataContact name={contactData.name || "N/A"} email={contactData.email || "N/A"} phone={contactData.phone || "N/A"} />
            {/* <DataContact data={contactData} /> */}
          </CardConfirmYourData>
        </div>
        <div className="flex justify-between items-center gap-3 group" data-is-signer={isSigner}>
          <ButtonComponent className="back-button group-data-[is-signer='true']:hidden" onClick={handleBackButtonClick}>
            Voltar
          </ButtonComponent>

          <ButtonComponent
            className="continue-button"
            onClick={() => {
              if (type === FluxoType.AUTOSSERVICO) modalRef.current?.open();
              else handleButtonClick();
            }}
            isDisabled={confirmarDadosLeadMutation.isPending}
          >
            Continuar
          </ButtonComponent>
        </div>
        {type === FluxoType.AUTOSSERVICO ? (
          <ConfirmFaturaDigitalModal
            ref={modalRef}
            isLoading={confirmarDadosLeadMutation.isPending || prepareTerm.isPending}
            onConfirm={async () => {
              handleButtonClick();

              return new Promise((resolve) => {
                setTimeout(() => {
                  modalRef.current?.close();
                  resolve();
                }, 600);
              });
            }}
          />
        ) : null}

        {(confirmarDadosLeadMutation.isPending || prepareTerm.isPending || isPending) && <LoadingFullPage />}
      </RightHomeComponent>
    </MainHomeComponent>
  );
};
